import React from "react";
import Input from "../../../../Components/Common/Input";
import { CategoryApiUrls, subTopicUrls } from "../../../../Api/Auth/ApiUrls";
import useSWR from "swr";
import Selector from "../../../../Components/Common/Selector";

const TopicForm = ({ onChange, handleSubmit, errors, formData }) => {
  const { isLoading, data } = useSWR(CategoryApiUrls.list);
  const { isLoading: subTopicLoading, data: subTopicData } = useSWR(
    subTopicUrls.list("")
  );

  return (
    <>
      <form onSubmit={handleSubmit} className="flex flex-col gap-2">
        <Input
          label="Title"
          type="text"
          name="title"
          value={formData.title}
          onChange={onChange}
          placeholder="Enter topic title"
          error={errors.title}
          required
        />
        <Input
          label="Description"
          type="text"
          name="description"
          value={formData.description}
          onChange={onChange}
          placeholder="Enter topic description"
          error={errors.description}
        />
        <Selector
          name="category"
          label="Category"
          value={formData?.category}
          options={data?.data?.map((item) => ({
            label: item.title,
            value: item._id,
          }))}
          isClearable={false}
          onChange={onChange}
          error={errors?.category}
          isLoading={isLoading}
          required
        />
        <Selector
          name="subtopic"
          label="Sub Topic"
          value={formData?.subtopic}
          options={subTopicData?.data?.map((item) => ({
            label: item.title,
            value: item._id,
          }))}
          isClearable={false}
          onChange={onChange}
          error={errors?.subtopic}
          isLoading={subTopicLoading}
          required
          multiple
        />
      </form>
    </>
  );
};

export default TopicForm;
